import styled, { css } from "styled-components";

const TabStyled = styled.button`
    font: inherit;
    padding: 2rem 1rem;
    display: inline-block;
    border: none;
    background: transparent;
    marginright: 1rem;
    cursor: pointer;
    height: inherit;
    flex-grow: 1;
    text-align: center;
    font-size: 1.4rem;
    border-right: ${props => props.theme.lightGrayBorder};
    &:last-child {
        border-right: 0;
    }
    /* focused */
    ${props => {
        return (
            props.active &&
            css`
                background: ${props.theme.lighterGreen};
            `
        );
    }}
`;

export default TabStyled;
